import { Routes } from '@/constants/routes';
import { type ClassValue, clsx } from 'clsx';
import Decimal from 'decimal.js';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const isHome = (pathname: string) => {
  return pathname === Routes.ROOT;
};

export const isMainPage = (pathname: string) => {
  return (
    pathname === Routes.ROOT ||
    pathname === Routes.HDB_RESALE ||
    pathname === Routes.PRIVATE_RESALE ||
    pathname === Routes.COMMERCIAL_INDUSTRIAL ||
    pathname === Routes.OTHERS
  );
};

export function formatUnit(value: number | string, unit: string, pluralUnit: string) {
  const number = +(value || 0);

  return `${number} ${number > 1 ? pluralUnit : unit}`;
}

export const roundNumber = (x?: string | number, fixedNumber?: number) => {
  if (!x) {
    return '';
  }

  if (typeof x === 'number') {
    const fixNumber = typeof fixedNumber === 'number' ? fixedNumber : 0;

    // Use Decimal.js for precise arithmetic
    const decimalValue = new Decimal(x);

    return decimalValue.toFixed(fixNumber);
  }

  return '';
};

export function numberWithCommas(x?: string | number, fixedNumber?: number) {
  if (!x) {
    return '';
  }

  let number = x;

  if (typeof x === 'number') {
    const fixNumber = typeof fixedNumber === 'number' ? fixedNumber : 0;

    // Use Decimal.js for precise arithmetic
    const decimalValue = new Decimal(x);

    number = decimalValue.toFixed(fixNumber);
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const roundToCurrency = (value: number) => Math.round(value);
